/**
 * True when `user` is an ephemeral GUEST account.
 *
 * Guests own the reserved `guest-<hex>` username namespace (see
 * `lib/auth/guest.ts`). The client `useAuth` User type narrows `accountType`
 * to `'human' | 'agent'`, so callers can't rely on `accountType === 'guest'`;
 * the reserved username prefix is the reliable client-side signal. This
 * helper accepts either shape (the menu's `UserMenuUser`, which does carry
 * `'guest'`, or the auth-provider User) so every surface detects guests the
 * same way.
 */
export function isGuestUser(
  user: { username?: string | null; accountType?: string | null } | null | undefined,
): boolean {
  if (!user) return false;
  if (user.accountType === 'guest') return true;
  return !!user.username && user.username.startsWith('guest-');
}
